import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=48a256db&scoped=true"
import script from "./OrgList.vue?vue&type=script&lang=js"
export * from "./OrgList.vue?vue&type=script&lang=js"
import style0 from "./OrgList.vue?vue&type=style&index=0&id=48a256db&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a256db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a256db')) {
      api.createRecord('48a256db', component.options)
    } else {
      api.reload('48a256db', component.options)
    }
    module.hot.accept("./OrgList.vue?vue&type=template&id=48a256db&scoped=true", function () {
      api.rerender('48a256db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reserve/OrgList.vue"
export default component.exports